"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScmAdapter = void 0;
const GcmAdapter_1 = require("./GcmAdapter");
const helperFunctions_1 = require("./utility/helperFunctions");
const Types_1 = require("./Types");
class ScmAdapter extends GcmAdapter_1.GcmAdapter {
    getDataCenterPrefix() {
        const dc = this.options.platformDataCenter;
        const dcPrefix = dc ? `-${dc}` : (0, helperFunctions_1.random)(1, 2);
        return dcPrefix;
    }
    getEndpoint() {
        switch (this.options.environment) {
            case 'production':
                return `https://cm${this.getDataCenterPrefix()}.7platform.com:8008`;
            default:
                return 'https://cm-staging2.7platform.com:8008';
        }
    }
    setName() {
        this.name = Types_1.Adapters.ScmAdapter;
    }
}
exports.ScmAdapter = ScmAdapter;
//# sourceMappingURL=ScmAdapter.js.map